import { useCallback, useRef } from 'react';
import { useMapStore } from '@/store/useMapStore';
import PaletteCard from './PaletteCard';

const COLUMNS = 4;

const PaletteGrid = () => {
  const { selectedPalette, setPalette, palettes } = useMapStore();
  const gridRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    const currentIndex = palettes.findIndex(p => p.id === selectedPalette);
    if (currentIndex === -1) return;

    let nextIndex = currentIndex;
    switch (e.key) {
      case 'ArrowRight':
        nextIndex = Math.min(currentIndex + 1, palettes.length - 1);
        break;
      case 'ArrowLeft':
        nextIndex = Math.max(currentIndex - 1, 0);
        break;
      case 'ArrowDown':
        nextIndex = Math.min(currentIndex + COLUMNS, palettes.length - 1);
        break;
      case 'ArrowUp':
        nextIndex = Math.max(currentIndex - COLUMNS, 0);
        break;
      default:
        return;
    }

    e.preventDefault();
    setPalette(palettes[nextIndex].id);

    const buttons = gridRef.current?.querySelectorAll('[role="radio"]');
    (buttons?.[nextIndex] as HTMLElement)?.focus();
  }, [selectedPalette, palettes, setPalette]);

  return (
    <div
      ref={gridRef}
      role="radiogroup"
      aria-label="Color palettes"
      onKeyDown={handleKeyDown}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${COLUMNS}, 1fr)`,
        gap: '10px',
      }}
    >
      {palettes.map(palette => (
        <PaletteCard
          key={palette.id}
          palette={palette}
          isSelected={selectedPalette === palette.id}
          onSelect={setPalette}
        />
      ))}
    </div>
  );
};

export default PaletteGrid;
